export default function () {
  return [
   { key: 'company' },
    { key: 'branchId', label: "businessUnit", type: 'bu', selectProps: { clearable: true, multiple: false } },
    { key: 'orgId', type: 'org', selectProps: { clearable: true, multiple: false } }
  ]
}
